import NiceModal from '@ebay/nice-modal-react';

import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'components/global/Modal';
import Tabs from 'components/global/Tabs';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAccessControl from 'hooks/useAccessControl';
import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { ORDERS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import OrderStatuses from './OrderStatuses';
import PackingStatuses from './PackingStatuses';
import TrackingInformations from './TrackingInformations';

const OrderStatusesModal = NiceModal.create(({ ID, orderID, shipmentNumber, orderStatusApiSource }) => {
	const { t } = useTranslation();
	const { showError } = useAlert();
	const axios = useAxiosPrivate();
	const isAuthorized = useAccessControl();
	const [trackingData, setTrackingData] = useState(null);

	const tabs = [
		{
			label: 'orderStatusHistory',
			component: () => <OrderStatuses ID={ID} apiSource={orderStatusApiSource} />
		},
		...(isAuthorized(['WMSModule', 'WMSAdvanceModule'])
			? [
					{
						label: 'packingStatusHistory',
						component: () => <PackingStatuses ID={ID} />
					}
				]
			: [])
	];

	const getTrackingData = useCallback(async () => {
		try {
			const response = await axios.post(ORDERS.GET_TRACKING_STATUS_BY_ID, { shipmentID: shipmentNumber });
			const { data } = response;
			setTrackingData(data);
		} catch (error) {
			AppLogger.error(error);
			showError({
				message: error?.response.data.code || error?.message
			});
		}
	}, []);

	useEffect(() => {
		if (shipmentNumber) {
			getTrackingData();
		}
	}, [shipmentNumber]);

	return (
		<Modal maxWidth="x-large" fullwidth className="modal-orderStatuses">
			<ModalTitle>
				<Typography variant="p1">
					{t('statusHistory')} (<strong>{orderID}</strong>)
				</Typography>
			</ModalTitle>
			<ModalContent style={{ width: '100%' }}>
				{shipmentNumber && trackingData && trackingData.showTracking && (
					<TrackingInformations data={trackingData} shipmentID={shipmentNumber} />
				)}
				<Tabs data={tabs} />
			</ModalContent>
		</Modal>
	);
});

export default OrderStatusesModal;
